module.exports = __webpack_public_path__ + "static/media/Arts, Schilling, Prayer Chapel bricks.1d763df0.png";